export default __webpack_public_path__ + "static/media/developer-illustration.94cf967b.png";